import { Form, Modal } from "react-bootstrap";
import "./VerifyCertifate.css";
import { FaRegUser } from "react-icons/fa";
import { MdOutlineMailOutline } from "react-icons/md";
import { GrCertificate } from "react-icons/gr";
import { IoSearchSharp } from "react-icons/io5";
import { useState } from "react";
import PostApiCall from "../../helpers/PostApi";
import Notiflix from "notiflix";
import { LuPhone } from "react-icons/lu";

export default function VerifyCertificate() {
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [certificateNumber, setCertificateNumber] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedImg, setSelectedImg] = useState("");
  const handleToggleModal = () => {
    setIsOpen(false);
  };
  const handleInputChange = (value) => {
    const mobileValue = value.replace(/[^0-9]/g, "").slice(0, 12);
    setMobile(mobileValue);
  };

  const GetCertificate = () => {
    if (!name) {
      Notiflix.Notify.failure("Please enter name");
      return;
    }
    if (!mobile || mobile?.length < 10) {
      Notiflix.Notify.failure("Please enter valid mobile number");
      return;
    }
    if (!certificateNumber) {
      Notiflix.Notify.failure("Please enter certificate number");
      return;
    }
    Notiflix.Loading.dots();
    PostApiCall.postRequest(
      {
        name: name,
        certificate: certificateNumber,
        mobile: mobile,
      },
      "GetCertificate"
    ).then((result) =>
      result.json().then((obj) => {
        if (result.status === 200 || result.status === 201) {
          // const url = URL.createObjectURL(obj.data[0]?.fld_certificate_url);
          setSelectedImg(obj.data[0]?.fld_certificate_url);
          setName("");
          setMobile("");
          setCertificateNumber("");
          setIsOpen(true);
          Notiflix.Loading.remove();
        } else {
          Notiflix.Loading.remove();
          Notiflix.Notify.failure(obj.data);
        }
      })
    );
  };

  return (
    <>
      <h2 className="d-lg-none  heading mt-4 px-4">
        Verify Your Diamond Certificate
      </h2>
      <section className="verify-certificate d-flex justify-content-between align-items-center ">
        <div className="verify-input name-input">
          <FaRegUser />

          {/* <Form.Group controlId="Name"> */}
          <Form.Control
            type="text"
            placeholder="Enter your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          {/* </Form.Group> */}
        </div>
        <div className="verify-input mail-input">
          <LuPhone />
          {/* <Form.Group controlId="Email"> */}
          <Form.Control
            type="text"
            placeholder="Enter your mobile"
            value={mobile}
            onChange={(e) => handleInputChange(e.target.value)}
          />
          {/* </Form.Group> */}
        </div>
        <div className="verify-input">
          {/* <Form.Group controlId="Verify Certificate"> */}
          <GrCertificate />
          <Form.Control
            className="border-0"
            type="text"
            placeholder="Certificate Number"
            value={certificateNumber}
            onChange={(e) =>
              setCertificateNumber(e.target.value?.toUpperCase())
            }
          />
          {/* </Form.Group> */}
        </div>

        <div
          className="verify-search"
          onClick={() => {
            GetCertificate();
          }}
        >
          <button type="button" className="button">
            <IoSearchSharp />
            <span className="d-lg-none">Search</span>
          </button>
          {/* <span className="d-flex justify-content-center d-lg-none w-100 button">
                        {" "}
                        <IoSearchSharp />
                        Search{" "}
                    </span> */}
        </div>
      </section>
      <Modal
        show={isOpen}
        centered
        onHide={() => {
          handleToggleModal();
        }}
      >
        <Modal.Header
          closeButton
          className="border-0 p-2 position-absolute right-0 bg-white z-3 top-0 end-0"
        />
        <Modal.Body className="p-2 d-flex justify-content-center">
          <>
            <img
              src={selectedImg || ""}
              className="img-fluid"
              alt="Preview"
              onContextMenu={(e) => e.preventDefault()}
              style={{ userSelect: "none", pointerEvents: "auto" }}
              draggable={false}
            />
          </>
        </Modal.Body>
      </Modal>
    </>
  );
}
